/**
 * @namespace ManageCookies
 * @memberof Promega.Shell
 * @description Methods for showing cookie options modal dialog and managing cookies.
 */

import trackEvent from '../util/trackEvent';
import cookie from 'cookie_js';
import { show as showModal, hide as hideModal, lock as lockModal, unlock as unlockModal } from '../components/modal.js';

const PROMEGA_COOKIE_POLICY         = "promegaCookiePolicy";
const PROMEGA_COOKIE_POLICY_MAX_AGE = 3652;   // 10 years in days

const COOKIE_ELEMENT_N = "necessaryCookiesCheckbox",
    COOKIE_ELEMENT_P = "preferenceCookiesCheckbox",
    COOKIE_ELEMENT_S = "performanceStatisticsCheckbox",
    COOKIE_ELEMENT_M = "marketingCookiesCheckbox";

const MANAGE_COOKIES_SELECT_CLASS = "manage-cookies-select-dialog";
const SAVE_BUTTON_CLASS = "modal-dialog__save-button";

const COOKIE_TYPE_U = 0;
const COOKIE_TYPE_N = 1;
const COOKIE_TYPE_P = 2;
const COOKIE_TYPE_S = 4;
const COOKIE_TYPE_M = 8;

/**
 * Calculate the sum of all selected cookie checkboxes
 */
function calculateNewCookieValue() {

    let sum = COOKIE_TYPE_N;

    let isCookiePChecked = document.getElementById(COOKIE_ELEMENT_P).checked;
    let isCookieSChecked = document.getElementById(COOKIE_ELEMENT_S).checked;
    let isCookieMChecked = document.getElementById(COOKIE_ELEMENT_M).checked;

    if (isCookiePChecked) { sum |= COOKIE_TYPE_P; }
    if (isCookieSChecked) { sum |= COOKIE_TYPE_S; }
    if (isCookieMChecked) { sum |= COOKIE_TYPE_M; }

    return sum;
}


/**
 * 
 * @param {any} cookieValue
 */
function checkCookieCheckBoxes(cookieValue) {

    document.getElementById(COOKIE_ELEMENT_N).checked = true;
    document.getElementById(COOKIE_ELEMENT_P).checked = (COOKIE_TYPE_P & cookieValue);
    document.getElementById(COOKIE_ELEMENT_S).checked = (COOKIE_TYPE_S & cookieValue);
    document.getElementById(COOKIE_ELEMENT_M).checked = (COOKIE_TYPE_M & cookieValue);
}

/**
 * Grabs existing promegacookievalue from browser cookies
 * and sets a default of 1 (Necessary) if it didn't exist
 */
function getExistingCookieValue() {

    let existingCookieValue = cookie.get(PROMEGA_COOKIE_POLICY, 'UNKNOWN');

    if (existingCookieValue === 'UNKNOWN') {
        existingCookieValue = setPromegaCookie(COOKIE_TYPE_N);
    }

    return existingCookieValue;
}

/**
 * Sets promegaCookiePolicy with correct expiry and other
 * cookie properties
 */
function setPromegaCookie(cookieValue) {

    cookie.set(PROMEGA_COOKIE_POLICY, cookieValue, {
        expires: PROMEGA_COOKIE_POLICY_MAX_AGE,
        path: "/"
    });

    return cookieValue;
}

function hideCookiePreferencesModal() {
    const COOKIE_MODAL_ELEMENT = document.querySelector(`.${MANAGE_COOKIES_SELECT_CLASS}`);
    if (COOKIE_MODAL_ELEMENT) {
        hideModal(COOKIE_MODAL_ELEMENT);
    }
}

/**
 * Shows the cookie preferences modal dialog.
 */
function showCookiePreferencesModal() {
    const COOKIE_MODAL_ELEMENT = document.querySelector(`.${MANAGE_COOKIES_SELECT_CLASS}`);

    let newCookie = getExistingCookieValue();
    checkCookieCheckBoxes(newCookie);

    if (COOKIE_MODAL_ELEMENT) {
        // COOKIE_MODAL_ELEMENT.style.width = "585px";
        showModal(COOKIE_MODAL_ELEMENT);
    }
}

function hideCookieAlertBanner() {
    let cookieAlertBanner = document.getElementById("cookiepolicy");
    if (cookieAlertBanner) cookieAlertBanner.style.display = "none";
}

function cookiePreferencesTriggerClicked(event) {
    if (event.target.classList.contains("trigger--manage-cookies-select")) {
        showCookiePreferencesModal();
        event.preventDefault();
    }
}

function selectAllCookies() {
    const cookieCheckboxes = document.querySelectorAll('.modal-dialog__form-input');
    for (let i = 0, j = cookieCheckboxes.length; i < j; i++) {
        cookieCheckboxes[i].checked = true;
    }
}

function cookieModalSubmitTrigger(event) {
    let newCookieValue = calculateNewCookieValue();
    setPromegaCookie(newCookieValue);
    Promega.Util.updateCookiePolicyConsent(newCookieValue);
    hideCookiePreferencesModal();
    hideCookieAlertBanner();
    trackEvent("Manage Cookies", "Save", newCookieValue);
    event.preventDefault();
}

function acceptAllTrigger(event) {
    if (event.target.classList.contains("trigger--accept-all-cookies")) {
        let cookieModalElement = document.querySelector("#cookiepolicy");
        let setCookieOnHide = cookieModalElement.getAttribute("data-set-cookie-on-hide");
        if (setCookieOnHide) {
            setCookieOnHide = JSON.parse(setCookieOnHide);
            if (setCookieOnHide.maxAge) {
                cookie.set(setCookieOnHide.name, setCookieOnHide.value, { "max-age": setCookieOnHide.maxAge, "path": "/" });
                console.warn("Cookies max-age option does not appear to be supported any longer (03/02/2021 CPAULY)");
            }
            else if (setCookieOnHide.expires) {
                cookie.set(setCookieOnHide.name, setCookieOnHide.value, { "expires": setCookieOnHide.expires, "path": "/" });
            }
            else {
                cookie.set(setCookieOnHide.name, setCookieOnHide.value, { path: "/" });
            }
        }
        Promega.Util.updateCookiePolicyConsent(15);
        hideCookieAlertBanner();
        hideModal();
    }
}


// Init code
if (typeof document !== "undefined") {
    document.body.addEventListener("click", acceptAllTrigger);
    document.body.addEventListener("click", cookiePreferencesTriggerClicked);
    const saveButton = document.querySelector(`.${SAVE_BUTTON_CLASS}`);
    saveButton.addEventListener("click", cookieModalSubmitTrigger);
    const selectAllButton = document.querySelector("#selectAllCookies");
    selectAllButton.addEventListener("click", selectAllCookies)
}